import { SVGProps } from 'react';

export const CircleSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="12"
    viewBox="0 0 11 12"
    fill="none"
  >
    <circle cx="5.5" cy="6" r="5" stroke="#9F9F9F" />
  </svg>
);

export const LocationPinPurpleSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="14"
    viewBox="0 0 11 14"
    fill="none"
  >
    <path
      d="M5.50005 3.00003C5.0056 3.00003 4.52224 3.14665 4.11111 3.42136C3.69999 3.69607 3.37955 4.08652 3.19033 4.54334C3.00111 5.00016 2.9516 5.50283 3.04807 5.98779C3.14453 6.47274 3.38264 6.9182 3.73227 7.26784C4.0819 7.61747 4.52737 7.85558 5.01232 7.95204C5.49728 8.04851 5.99995 7.999 6.45677 7.80978C6.91359 7.62056 7.30404 7.30012 7.57875 6.88899C7.85346 6.47787 8.00008 5.99451 8.00008 5.50006C8.00008 4.83701 7.73668 4.20112 7.26784 3.73227C6.79899 3.26342 6.1631 3.00003 5.50005 3.00003ZM5.50005 7.00007C5.20338 7.00007 4.91337 6.9121 4.66669 6.74727C4.42001 6.58245 4.22775 6.34818 4.11422 6.07409C4.00069 5.79999 3.97098 5.49839 4.02886 5.20742C4.08674 4.91644 4.2296 4.64917 4.43938 4.43938C4.64916 4.2296 4.91644 4.08674 5.20742 4.02886C5.49839 3.97098 5.79999 4.00069 6.07409 4.11422C6.34818 4.22775 6.58245 4.42002 6.74727 4.66669C6.9121 4.91337 7.00007 5.20338 7.00007 5.50006C7.00007 5.89788 6.84203 6.27942 6.56073 6.56073C6.27942 6.84203 5.89788 7.00007 5.50005 7.00007ZM5.50005 0C4.04186 0.00165422 2.64386 0.581654 1.61276 1.61276C0.581654 2.64386 0.00165422 4.04186 0 5.50006C0 7.46257 0.906884 9.5426 2.62503 11.5157C3.39705 12.4074 4.26595 13.2102 5.21568 13.9095C5.29975 13.9684 5.39991 14 5.50255 14C5.6052 14 5.70536 13.9684 5.78943 13.9095C6.73741 13.2099 7.60463 12.4071 8.37508 11.5157C10.0907 9.5426 11.0001 7.46257 11.0001 5.50006C10.9985 4.04186 10.4185 2.64386 9.38735 1.61276C8.35625 0.581654 6.95825 0.00165422 5.50005 0ZM5.50005 12.8751C4.46692 12.0626 1.00001 9.07822 1.00001 5.50006C1.00001 4.30657 1.47412 3.16196 2.31804 2.31804C3.16196 1.47412 4.30657 1.00001 5.50005 1.00001C6.69354 1.00001 7.83814 1.47412 8.68207 2.31804C9.52599 3.16196 10.0001 4.30657 10.0001 5.50006C10.0001 9.07697 6.53319 12.0626 5.50005 12.8751Z"
      fill="#6600CC"
    />
  </svg>
);

export const SwapArrowsSVG = ({ className }: { className?: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M2 10L14 10"
      stroke="#666666"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 10L10 14"
      stroke="#666666"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 6L2 6"
      stroke="#666666"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 6.00001L6 2"
      stroke="#666666"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CarIconSVG = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.4783 4.05772C2.66527 3.12287 3.4861 2.44995 4.43946 2.44995H9.56025C10.5136 2.44995 11.3344 3.12287 11.5214 4.05772L11.8999 5.94995H2.09985L2.4783 4.05772Z"
      stroke="#666666"
    />
    <path
      d="M0.699951 8.94995C0.699951 7.2931 2.0431 5.94995 3.69995 5.94995H10.3C11.9568 5.94995 13.3 7.2931 13.3 8.94995V10.65C13.3 10.7604 13.2104 10.85 13.1 10.85H0.899951C0.789494 10.85 0.699951 10.7604 0.699951 10.65V8.94995Z"
      stroke="#666666"
    />
    <path
      d="M3.69985 8.39985C3.69985 8.70361 3.45361 8.94985 3.14985 8.94985C2.8461 8.94985 2.59985 8.70361 2.59985 8.39985C2.59985 8.0961 2.8461 7.84985 3.14985 7.84985C3.45361 7.84985 3.69985 8.0961 3.69985 8.39985Z"
      stroke="#666666"
    />
    <circle cx="10.85" cy="8.39985" r="0.55" stroke="#666666" />
    <path
      d="M5.25 2.0999C5.25 1.7133 5.5634 1.3999 5.95 1.3999H8.05C8.4366 1.3999 8.75 1.7133 8.75 2.0999V2.4499H5.25V2.0999Z"
      fill="#666666"
    />
    <path
      d="M4.8999 9.44995L9.0999 9.44995"
      stroke="#666666"
      strokeLinecap="round"
    />
    <path
      d="M9.80005 10.8499H11.9V11.8999C11.9 12.4798 11.4299 12.9499 10.85 12.9499V12.9499C10.2702 12.9499 9.80005 12.4798 9.80005 11.8999V10.8499Z"
      stroke="#666666"
    />
    <path
      d="M2.09985 10.8499H4.19985V11.8999C4.19985 12.4798 3.72975 12.9499 3.14985 12.9499V12.9499C2.56995 12.9499 2.09985 12.4798 2.09985 11.8999V10.8499Z"
      stroke="#666666"
    />
  </svg>
);

export const ShieldTickSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <g clipPath="url(#clip0_2658_61692)">
      <path
        d="M5.87625 11.6906C5.87625 11.6906 10.2525 9.5025 10.2525 6.22031V2.39109L5.87625 0.75L1.5 2.39109V6.22031C1.5 9.5025 5.87625 11.6906 5.87625 11.6906Z"
        stroke="#666666"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.625 4.125L5.39062 8.29167L3.75 6.56818"
        stroke="#666666"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2658_61692">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const BoltSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M6.5 1L1.5 7H6L5.5 11L10.5 5H6L6.5 1Z"
      stroke="#888888"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TailedArrowSVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    {...props}
  >
    <path
      d="M2.625 7L11.375 7"
      stroke="#6600CC"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 2.625L11.375 7L7 11.375"
      stroke="#6600CC"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CashbackCoinSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      d="M11.9024 20.6262C7.57034 20.6262 1.79297 17.7057 1.79297 11.8663C1.79297 5.72467 5.85705 2.35668 11.9024 2.35668V20.6262Z"
      fill="#E29700"
    />
    <path
      d="M11.9026 2.67983C16.3522 2.67983 19.9594 6.6231 19.9594 11.4874C19.9594 16.3516 16.3522 20.2949 11.9026 20.2949C7.45288 20.2949 3.8457 16.3516 3.8457 11.4874C3.8457 6.6231 7.45288 2.67983 11.9026 2.67983Z"
      fill="#FFCE00"
    />
    <path
      d="M11.9029 2.34516C7.27587 2.34516 3.51172 6.44613 3.51172 11.487C3.51172 16.5279 7.27587 20.6289 11.9029 20.6289C16.5299 20.6289 20.2941 16.5279 20.2941 11.487C20.2941 6.44613 16.5299 2.34516 11.9029 2.34516ZM11.9029 19.9605C7.64461 19.9605 4.18038 16.1594 4.18038 11.4873C4.18038 6.81512 7.64461 3.01407 11.9029 3.01407C16.1612 3.01407 19.6254 6.81512 19.6254 11.4873C19.6254 16.1594 16.1612 19.9605 11.9029 19.9605Z"
      fill="#E29700"
    />
    <path
      d="M11.9032 5.16711C8.68903 5.16711 6.07422 8.00231 6.07422 11.4875C6.07422 14.9727 8.68903 17.8076 11.9032 17.8076C15.1174 17.8076 17.7322 14.9724 17.7322 11.4875C17.7322 8.00256 15.1174 5.16711 11.9032 5.16711ZM11.9032 16.6932C9.30359 16.6932 7.18841 14.3578 7.18841 11.4872C7.18841 8.61663 9.30359 6.2813 11.9032 6.2813C14.5028 6.2813 16.618 8.61663 16.618 11.4872C16.618 14.3578 14.5028 16.6932 11.9032 16.6932Z"
      fill="#E29700"
    />
  </svg>
);

export const CheckPurpleCircleSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M9 1.6875C7.55373 1.6875 6.13993 2.11637 4.9374 2.91988C3.73486 3.72339 2.7976 4.86544 2.24413 6.20163C1.69067 7.53781 1.54586 9.00811 1.82801 10.4266C2.11017 11.8451 2.80661 13.148 3.82928 14.1707C4.85196 15.1934 6.15492 15.8898 7.57341 16.172C8.99189 16.4541 10.4622 16.3093 11.7984 15.7559C13.1346 15.2024 14.2766 14.2651 15.0801 13.0626C15.8836 11.8601 16.3125 10.4463 16.3125 9C16.3105 7.06123 15.5394 5.20246 14.1685 3.83154C12.7975 2.46063 10.9388 1.68955 9 1.6875ZM12.2105 7.71047L8.27297 11.648C8.22073 11.7003 8.15869 11.7418 8.09041 11.7701C8.02212 11.7984 7.94892 11.8129 7.875 11.8129C7.80108 11.8129 7.72789 11.7984 7.6596 11.7701C7.59131 11.7418 7.52928 11.7003 7.47703 11.648L5.78953 9.96047C5.68399 9.85492 5.62469 9.71177 5.62469 9.5625C5.62469 9.41323 5.68399 9.27008 5.78953 9.16453C5.89508 9.05898 6.03824 8.99969 6.1875 8.99969C6.33677 8.99969 6.47992 9.05898 6.58547 9.16453L7.875 10.4548L11.4145 6.91453C11.4668 6.86227 11.5288 6.82081 11.5971 6.79253C11.6654 6.76424 11.7386 6.74969 11.8125 6.74969C11.8864 6.74969 11.9596 6.76424 12.0279 6.79253C12.0962 6.82081 12.1582 6.86227 12.2105 6.91453C12.2627 6.96679 12.3042 7.02884 12.3325 7.09712C12.3608 7.1654 12.3753 7.23859 12.3753 7.3125C12.3753 7.38641 12.3608 7.4596 12.3325 7.52788C12.3042 7.59616 12.2627 7.65821 12.2105 7.71047Z"
      fill="#8000FF"
    />
  </svg>
);

export const PhoneSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M17 2H7C5.89543 2 5 2.89543 5 4V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V4C19 2.89543 18.1046 2 17 2Z"
      stroke="#8000FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 18H12.01"
      stroke="#8000FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowCircleRight = (props: any) => (
  <svg
    width="37"
    height="36"
    viewBox="0 0 37 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="18.5"
      cy="18"
      r="17.5089"
      stroke="#797979"
      strokeOpacity="0.6"
      strokeWidth="0.982287"
    />
    <g clipPath="url(#clip0_3531_60287)">
      <path
        d="M15.1666 11.3332L21.8333 17.9999L15.1666 24.6666"
        stroke="#444444"
        strokeWidth="1.47343"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3531_60287">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="matrix(-1 0 0 1 26.5 9.99988)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const SparklesSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M12.3488 8.06625L9.12317 6.87875L7.93567 3.65062C7.86534 3.45958 7.73811 3.2947 7.57114 3.17824C7.40417 3.06178 7.20549 2.99933 7.00192 2.99933C6.79834 2.99933 6.59966 3.06178 6.43269 3.17824C6.26572 3.2947 6.13849 3.45958 6.06817 3.65062L4.87942 6.875L1.65129 8.0625C1.46025 8.13282 1.29537 8.26005 1.17891 8.42702C1.06244 8.594 1 8.79267 1 8.99625C1 9.19983 1.06244 9.3985 1.17891 9.56548C1.29537 9.73245 1.46025 9.85968 1.65129 9.93L4.87504 11.125L6.06254 14.3512C6.13286 14.5423 6.26009 14.7072 6.42707 14.8236C6.59404 14.9401 6.79272 15.0025 6.99629 15.0025C7.19987 15.0025 7.39854 14.9401 7.56552 14.8236C7.73249 14.7072 7.85972 14.5423 7.93004 14.3512L9.11754 11.1256L12.3457 9.93812C12.5367 9.8678 12.7016 9.74057 12.8181 9.5736C12.9345 9.40663 12.997 9.20795 12.997 9.00438C12.997 8.8008 12.9345 8.60212 12.8181 8.43515C12.7016 8.26818 12.5367 8.14095 12.3457 8.07063L12.3488 8.06625ZM8.77442 10.1875C8.6393 10.2371 8.51659 10.3155 8.41482 10.4173C8.31304 10.519 8.23463 10.6418 8.18504 10.7769L6.99754 13.9931L5.81254 10.7744C5.76291 10.64 5.68475 10.5179 5.58344 10.4166C5.48213 10.3153 5.36007 10.2371 5.22567 10.1875L2.00942 9L5.22567 7.8125C5.36007 7.76287 5.48213 7.68471 5.58344 7.5834C5.68475 7.48209 5.76291 7.36003 5.81254 7.22563L7.00004 4.00938L8.18754 7.22563C8.23713 7.36074 8.31554 7.48345 8.41732 7.58523C8.51909 7.687 8.6418 7.76541 8.77692 7.815L11.9932 9.0025L8.77442 10.1875ZM9.00004 2.5C9.00004 2.36739 9.05272 2.24021 9.14649 2.14645C9.24026 2.05268 9.36743 2 9.50004 2H10.5V1C10.5 0.867392 10.5527 0.740215 10.6465 0.646447C10.7403 0.552678 10.8674 0.5 11 0.5C11.1326 0.5 11.2598 0.552678 11.3536 0.646447C11.4474 0.740215 11.5 0.867392 11.5 1V2H12.5C12.6326 2 12.7598 2.05268 12.8536 2.14645C12.9474 2.24021 13 2.36739 13 2.5C13 2.63261 12.9474 2.75979 12.8536 2.85355C12.7598 2.94732 12.6326 3 12.5 3H11.5V4C11.5 4.13261 11.4474 4.25979 11.3536 4.35355C11.2598 4.44732 11.1326 4.5 11 4.5C10.8674 4.5 10.7403 4.44732 10.6465 4.35355C10.5527 4.25979 10.5 4.13261 10.5 4V3H9.50004C9.36743 3 9.24026 2.94732 9.14649 2.85355C9.05272 2.75979 9.00004 2.63261 9.00004 2.5ZM15.5 5.5C15.5 5.63261 15.4474 5.75979 15.3536 5.85355C15.2598 5.94732 15.1326 6 15 6H14.5V6.5C14.5 6.63261 14.4474 6.75979 14.3536 6.85355C14.2598 6.94732 14.1326 7 14 7C13.8674 7 13.7403 6.94732 13.6465 6.85355C13.5527 6.75979 13.5 6.63261 13.5 6.5V6H13C12.8674 6 12.7403 5.94732 12.6465 5.85355C12.5527 5.75979 12.5 5.63261 12.5 5.5C12.5 5.36739 12.5527 5.24021 12.6465 5.14645C12.7403 5.05268 12.8674 5 13 5H13.5V4.5C13.5 4.36739 13.5527 4.24021 13.6465 4.14645C13.7403 4.05268 13.8674 4 14 4C14.1326 4 14.2598 4.05268 14.3536 4.14645C14.4474 4.24021 14.5 4.36739 14.5 4.5V5H15C15.1326 5 15.2598 5.05268 15.3536 5.14645C15.4474 5.24021 15.5 5.36739 15.5 5.5Z"
      fill="#FFF2F8"
    />
  </svg>
);

export const ThreeCirclesSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M10.75 4.75C10.75 4.2061 10.5887 3.67442 10.2865 3.22218C9.98437 2.76995 9.55488 2.41747 9.05238 2.20933C8.54988 2.00119 7.99695 1.94673 7.4635 2.05284C6.93006 2.15895 6.44005 2.42086 6.05546 2.80546C5.67086 3.19005 5.40895 3.68005 5.30284 4.2135C5.19673 4.74695 5.25119 5.29988 5.45933 5.80238C5.66747 6.30488 6.01995 6.73437 6.47218 7.03654C6.92442 7.33872 7.4561 7.5 8 7.5C8.72909 7.49917 9.42809 7.20918 9.94363 6.69363C10.4592 6.17809 10.7492 5.47909 10.75 4.75ZM8 6.5C7.65388 6.5 7.31554 6.39737 7.02775 6.20507C6.73997 6.01278 6.51567 5.73947 6.38321 5.4197C6.25076 5.09993 6.2161 4.74806 6.28363 4.40859C6.35115 4.06913 6.51782 3.75731 6.76256 3.51256C7.00731 3.26782 7.31913 3.10115 7.65859 3.03363C7.99806 2.9661 8.34993 3.00076 8.6697 3.13321C8.98947 3.26567 9.26278 3.48997 9.45507 3.77775C9.64737 4.06554 9.75 4.40388 9.75 4.75C9.75 5.21413 9.56563 5.65925 9.23744 5.98744C8.90925 6.31563 8.46413 6.5 8 6.5ZM11.75 8C11.2061 8 10.6744 8.16129 10.2222 8.46346C9.76995 8.76563 9.41747 9.19513 9.20933 9.69762C9.00119 10.2001 8.94673 10.7531 9.05284 11.2865C9.15895 11.8199 9.42086 12.31 9.80546 12.6945C10.1901 13.0791 10.6801 13.3411 11.2135 13.4472C11.747 13.5533 12.2999 13.4988 12.8024 13.2907C13.3049 13.0825 13.7344 12.7301 14.0365 12.2778C14.3387 11.8256 14.5 11.2939 14.5 10.75C14.4992 10.0209 14.2092 9.32192 13.6936 8.80637C13.1781 8.29083 12.4791 8.00083 11.75 8ZM11.75 12.5C11.4039 12.5 11.0655 12.3974 10.7778 12.2051C10.49 12.0128 10.2657 11.7395 10.1332 11.4197C10.0008 11.0999 9.9661 10.7481 10.0336 10.4086C10.1012 10.0691 10.2678 9.75731 10.5126 9.51256C10.7573 9.26782 11.0691 9.10115 11.4086 9.03363C11.7481 8.9661 12.0999 9.00076 12.4197 9.13321C12.7395 9.26567 13.0128 9.48997 13.2051 9.77775C13.3974 10.0655 13.5 10.4039 13.5 10.75C13.5 11.2141 13.3156 11.6592 12.9874 11.9874C12.6592 12.3156 12.2141 12.5 11.75 12.5ZM4.25 8C3.7061 8 3.17442 8.16129 2.72218 8.46346C2.26995 8.76563 1.91747 9.19513 1.70933 9.69762C1.50119 10.2001 1.44673 10.7531 1.55284 11.2865C1.65895 11.8199 1.92086 12.31 2.30546 12.6945C2.69005 13.0791 3.18006 13.3411 3.7135 13.4472C4.24695 13.5533 4.79988 13.4988 5.30238 13.2907C5.80488 13.0825 6.23437 12.7301 6.53654 12.2778C6.83872 11.8256 7 11.2939 7 10.75C6.99917 10.0209 6.70918 9.32192 6.19363 8.80637C5.67809 8.29083 4.97909 8.00083 4.25 8ZM4.25 12.5C3.90388 12.5 3.56554 12.3974 3.27775 12.2051C2.98997 12.0128 2.76567 11.7395 2.63321 11.4197C2.50076 11.0999 2.4661 10.7481 2.53363 10.4086C2.60115 10.0691 2.76782 9.75731 3.01256 9.51256C3.25731 9.26782 3.56913 9.10115 3.90859 9.03363C4.24806 8.9661 4.59993 9.00076 4.9197 9.13321C5.23947 9.26567 5.51278 9.48997 5.70507 9.77775C5.89737 10.0655 6 10.4039 6 10.75C6 11.2141 5.81563 11.6592 5.48744 11.9874C5.15925 12.3156 4.71413 12.5 4.25 12.5Z"
      fill="#444444"
    />
  </svg>
);

export const PassengerSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="11"
    viewBox="0 0 12 11"
    fill="none"
  >
    <path
      d="M11.3792 10.78C11.3405 10.8469 11.285 10.9025 11.2181 10.9411C11.1512 10.9797 11.0753 11 10.9981 11H0.439489C0.362302 10.9999 0.286494 10.9795 0.219677 10.9409C0.152861 10.9022 0.0973875 10.8467 0.058828 10.7798C0.0202686 10.713 -1.98018e-05 10.6371 1.45025e-08 10.5599C1.98308e-05 10.4828 0.0203472 10.4069 0.0589409 10.3401C0.896477 8.89214 2.18715 7.85388 3.6934 7.3617C2.94834 6.91816 2.36948 6.24231 2.0457 5.43794C1.72193 4.63358 1.67115 3.74517 1.90116 2.90915C2.13117 2.07313 2.62925 1.33572 3.31891 0.810175C4.00857 0.284628 4.85169 0 5.71877 0C6.58586 0 7.42897 0.284628 8.11863 0.810175C8.8083 1.33572 9.30638 2.07313 9.53638 2.90915C9.76639 3.74517 9.71561 4.63358 9.39184 5.43794C9.06807 6.24231 8.4892 6.91816 7.74415 7.3617C9.25039 7.85388 10.5411 8.89214 11.3786 10.3401C11.4173 10.4069 11.4377 10.4828 11.4378 10.56C11.4379 10.6372 11.4177 10.7131 11.3792 10.78Z"
      fill="#ECD9FF"
    />
  </svg>
);

export const LuggageIconSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="16"
    viewBox="0 0 11 16"
    fill="none"
  >
    <path
      d="M9.9 3H8.25V1.5C8.25 1.10218 8.07616 0.720644 7.76673 0.43934C7.45729 0.158035 7.03761 0 6.6 0L4.4 0C3.96239 0 3.54271 0.158035 3.23327 0.43934C2.92384 0.720644 2.75 1.10218 2.75 1.5V3H1.1C0.808262 3 0.528472 3.10536 0.322183 3.29289C0.115892 3.48043 0 3.73478 0 4V13C0 13.2652 0.115892 13.5196 0.322183 13.7071C0.528472 13.8946 0.808262 14 1.1 14H2.2V15C2.2 15.1326 2.25795 15.2598 2.36109 15.3536C2.46424 15.4473 2.60413 15.5 2.75 15.5C2.89587 15.5 3.03576 15.4473 3.13891 15.3536C3.24205 15.2598 3.3 15.1326 3.3 15V14H7.7V15C7.7 15.1326 7.75795 15.2598 7.86109 15.3536C7.96424 15.4473 8.10413 15.5 8.25 15.5C8.39587 15.5 8.53576 15.4473 8.63891 15.3536C8.74205 15.2598 8.8 15.1326 8.8 15V14H9.9C10.1917 14 10.4715 13.8946 10.6778 13.7071C10.8841 13.5196 11 13.2652 11 13V4C11 3.73478 10.8841 3.48043 10.6778 3.29289C10.4715 3.10536 10.1917 3 9.9 3ZM3.3 12C3.3 12.1326 3.24205 12.2598 3.13891 12.3536C3.03576 12.4473 2.89587 12.5 2.75 12.5C2.60413 12.5 2.46424 12.4473 2.36109 12.3536C2.25795 12.2598 2.2 12.1326 2.2 12V5C2.2 4.86739 2.25795 4.74021 2.36109 4.64645C2.46424 4.55268 2.60413 4.5 2.75 4.5C2.89587 4.5 3.03576 4.55268 3.13891 4.64645C3.24205 4.74021 3.3 4.86739 3.3 5V12ZM6.05 12C6.05 12.1326 5.99205 12.2598 5.88891 12.3536C5.78576 12.4473 5.64587 12.5 5.5 12.5C5.35413 12.5 5.21424 12.4473 5.11109 12.3536C5.00795 12.2598 4.95 12.1326 4.95 12V5C4.95 4.86739 5.00795 4.74021 5.11109 4.64645C5.21424 4.55268 5.35413 4.5 5.5 4.5C5.64587 4.5 5.78576 4.55268 5.88891 4.64645C5.99205 4.74021 6.05 4.86739 6.05 5V12ZM7.15 3H3.85V1.5C3.85 1.36739 3.90795 1.24021 4.01109 1.14645C4.11424 1.05268 4.25413 1 4.4 1H6.6C6.74587 1 6.88576 1.05268 6.98891 1.14645C7.09205 1.24021 7.15 1.36739 7.15 1.5V3ZM8.8 12C8.8 12.1326 8.74205 12.2598 8.63891 12.3536C8.53576 12.4473 8.39587 12.5 8.25 12.5C8.10413 12.5 7.96424 12.4473 7.86109 12.3536C7.75795 12.2598 7.7 12.1326 7.7 12V5C7.7 4.86739 7.75795 4.74021 7.86109 4.64645C7.96424 4.55268 8.10413 4.5 8.25 4.5C8.39587 4.5 8.53576 4.55268 8.63891 4.64645C8.74205 4.74021 8.8 4.86739 8.8 5V12Z"
      fill="#ECD9FF"
    />
  </svg>
);

export const MapSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M1.5 6.81818V22.0909L8.18182 18.2727L15.8182 22.0909L22.5 18.2727V3L15.8182 6.81818L8.18182 3L1.5 6.81818Z"
      stroke="#8000FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.18188 3V18.2727"
      stroke="#8000FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.8181 6.81818V22.0909"
      stroke="#8000FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
